/*
 *
 * SearchForm
 *
 */

import {} from "@ant-design/icons";
import { message } from "antd";
import { useEffect, useRef, useState } from "react";
// import { getUrl } from '../../../utils';
import { Editor } from "@tinymce/tinymce-react";
import { request } from "@umijs/max";
import appConfig from "@/appConfig";
import "./ckeditor5.scss";

const CustomImageUpload = ({
  value = "",
  onChange,
  onLoadingState,
  uploadUrl,
  disabled,
}: any) => {
  const [messageApi, contextHolder]: any = message.useMessage();
  const [content, setContent]: any = useState("");
  const editorRef: any = useRef(null);
  //页面加载首次渲染
  useEffect(() => {
    if (value !== editorRef.current?.getContent()) setContent(value);
  }, [value]);
  useEffect(() => {
    editorInit(null, editorRef.current);
  }, [disabled]);
  const editorInit = (evt: any, editor: any) => {
    editorRef.current = editor;
    editor?.getBody()?.setAttribute("contenteditable", !disabled);
  };
  return (
    <>
      {contextHolder}
      <Editor
        tinymceScriptSrc={"/tinymce/tinymce.min.js"}
        onInit={editorInit}
        initialValue={content}
        init={{
          height: 500,
          menubar: false,
          // extended_valid_elements:
          //   "style[type|media],xml[*],o:OfficeDocumentSettings,o:PixelsPerInch,o:AllowPNG",
          valid_elements: "*[*]", // 允许所有元素和属性
          // verify_html: false, // 禁用 HTML 验证
          // cleanup: false, // 禁用自动清理内容
          // forced_root_block: false, // 禁止自动添加 <p> 标签
          // remove_trailing_brs: false, // 禁止移除末尾的 <br> 标签
          // content_style: "", // 清空默认内容样式
          // custom_elements:
          //   "xml,o:OfficeDocumentSettings,o:PixelsPerInch,o:AllowPNG",
          valid_children: "+body[style]", // 确保 <style> 标签被允许在 <body> 内部
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "preview",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo  blocks  " +
            "bold italic forecolor alignleft aligncenter " +
            "alignright alignjustify bullist numlist outdent indent " +
            "removeformat link image code help",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          automatic_uploads: true,
          images_upload_handler: (blobInfo: any, progress: any) =>
            new Promise(async (resolve, reject) => {
              // 模拟上传文件到S3，并在上传成功后返回文件的URL
              // 假设文件上传成功，并得到了文件的URL
              if (onLoadingState) onLoadingState(true);
              const file = blobInfo.blob();
              // console.log(file, 'file-888')
              var formData = new FormData();
              formData.append('file', file, blobInfo.filename());
              let uploadedFileUrl = 'null';
              // const { data } = await post(getUrl(uploadUrl), formData, {
              // const { data } = await post(uploadUrl, formData, {
              //   headers: { 'Content-Type': 'multipart/form-data' },
              // });
              let url = uploadUrl || '/uploadGameResource';
              const res = await request(appConfig?.apiBaseURL + url, {
                method: 'POST',
                headers: { 'Content-Type': 'multipart/form-data' },
                data: formData,
              });
              if (res.code === 0) {
                uploadedFileUrl = res.data?.host + res.data?.uri;
                // console.log(data, 'data-uploadGameResource');
                // console.log(uploadedFileUrl, 'uploadedFileUrl-888');
              } else {
                messageApi.error(res.msg);
              }
              resolve(uploadedFileUrl);
              // multipart/form-data
              setTimeout(() => {
                if (onLoadingState) onLoadingState(false);
              }, 2000);
            }),
        }}
        onEditorChange={(content: any, editor: any) => {
          onChange(content);
        }}
      />
    </>
  );
};

export default CustomImageUpload;
